import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import "./Modal.css";
import { SiTicktick } from "react-icons/si";
import { MdError, MdInfo } from "react-icons/md";
import { IoChevronForward, IoClose } from "react-icons/io5";
import { NotificationContext } from "../../context/NotificationContext";

const NotificationModal = () => {
    const { notification, hideNotification } = useContext(NotificationContext);

    const getIcon = () => {
        switch (notification.type) {
            case "success":
                return <SiTicktick color="#28a745" size={48} />;
            case "error":
                return <MdError color="#dc3545" size={48} />;
            case "info":
                return <MdInfo color="#4a90e2" size={48} />;
            default:
                return <SiTicktick color="#28a745" size={48} />;
        }
    };

    const getTitle = () => {
        switch (notification.type) {
            case "success":
                return "Success";
            case "error":
                return "Error";
            case "info":
                return "Information";
            default:
                return "Notification";
        }
    };

    return (
        <Modal
            show={notification.show}
            onHide={hideNotification}
            centered
            className={`notification-modal notification-modal--${notification.type}`}
            aria-labelledby="notification-modal-title"
            aria-describedby="notification-modal-message"
        >
            <Modal.Header className="custom-header">
                <span className="notification-modal__eyebrow">1EYE Chain update</span>
                <button
                    type="button"
                    className="custom-close"
                    onClick={hideNotification}
                    aria-label="Close notification"
                >
                    <IoClose size={22} aria-hidden="true" />
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="img-box" aria-hidden="true">{getIcon()}</div>
                <div className="content">
                    <h1 id="notification-modal-title">{getTitle()}</h1>
                    <p id="notification-modal-message">{notification.message}</p>
                    {notification.link && (
                        <a
                            className="notification-modal__link"
                            href={notification.link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            View details <IoChevronForward aria-hidden="true" />
                        </a>
                    )}
                </div>
                <button type="button" onClick={hideNotification} className="buy-more">
                    Close
                </button>
            </Modal.Body>
        </Modal>
    );
};

export default NotificationModal;
